export enum EventName {
    PROJECT_CREATED = 'project.created',
    ENTITY_CREATED = 'entity.created',

    COMMAND_SEND = `command.send`,

    ENTITY_CHANGED = `entity.changed`,
}